<template>
  <div class="base-nav">
    <div class="container">
      <transition name="fade-delay">
        <router-link class="menu-button" to="/menu" v-if="!menuDisabled && !loading">
          <BaseButtonMenu/>
        </router-link>
      </transition>
      <BaseButtonAudio class="audio-button"/>
      <transition name="fade">
        <BaseLoaderOctagon class="loader" v-if="loading"/>
      </transition>
    </div>
  </div>
</template>

<script>
import BaseLoaderOctagon from '@/components/BaseLoaderOctagon/BaseLoaderOctagon'
import BaseButtonMenu from '@/components/BaseButtonMenu/BaseButtonMenu'
import BaseButtonAudio from '@/components/BaseButtonAudio/BaseButtonAudio'
import { mapState } from 'vuex'
export default {
  components: {
    BaseLoaderOctagon,
    BaseButtonMenu,
    BaseButtonAudio
  },
  data () {
    return {
      menuDisabledRoutes: [
        '/',
        '/loading',
        '/menu',
        '/calibration',
        '/gameplay',
        '/results',
        '/login',
        '/form',
        '/optin',
        '/unsupported',
        '/maintenance'
      ]
    }
  },
  computed: {
    menuDisabled () {
      return this.menuDisabledRoutes.includes(this.$route.path)
    },
    ...mapState('ui', [
      'loading'
    ])
  }
}
</script>

<style lang="scss" scoped>
.base-nav {
  position: absolute;
  width: 100%;
  padding: var(--spacing-1);
  pointer-events: none;
  z-index: 2;
}
.container {
  width: 100%;
  height: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.menu-button {
  position: relative;
  height: 100%;
  pointer-events: all;
}
.audio-button {
  position: relative;
  height: 100%;
  pointer-events: all;
  margin-left: auto;
}
.loader {
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5rem;
}
.menu-button::before,
.audio-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  cursor: pointer;
}
</style>
